import { memo } from "react";
import { literals } from "@/constants/literals";

export interface EditionModalRadioGroupProps {
  label: string;
  selected: boolean | undefined;
  onChange: (value?: boolean) => void;
}

const EditionModalRadioGroup = ({
  label,
  selected,
  onChange,
}: EditionModalRadioGroupProps) => {
  const chageToTrue = () => {
    onChange(true);
  };

  const chageToFalse = () => {
    onChange(false);
  };

  return (
    <div
      className="gap-x-1 text-[14px] leading-[16px] mb-4"
      data-testid={`radio-group-${label}`}
    >
      <div className="text-ib-pt-color-neutral-800 pb-1">
        <span>{label}</span>
      </div>
      <div className="w-full flex flex-row gap-x-2">
        <div className="h-[42px] flex-1 border border-ib-pt-color-gray-100 rounded-[2px] p-2 flex items-center">
          <input
            type="radio"
            id={`${label}-yes`}
            name={`${label}-yes`}
            value={"true"}
            className="accent-ib-pt-color-red-500"
            onChange={chageToTrue}
            checked={selected}
          />
          <label
            htmlFor={`${label}-yes`}
            className="text-[14px] leading-5 ml-2 flex-1"
          >
            {literals.yes}
          </label>
        </div>
        <div className="h-[42px] flex-1 border border-ib-pt-color-gray-100 rounded-[2px] p-2 flex items-center">
          <input
            type="radio"
            id={`${label}-no`}
            name={`${label}-no`}
            value="false"
            className="accent-ib-pt-color-red-500"
            onChange={chageToFalse}
            checked={selected === false}
          />
          <label
            htmlFor={`${label}-no`}
            className="text-[14px] leading-5 ml-2 flex-1"
          >
            {literals.no}
          </label>
        </div>
      </div>
    </div>
  );
};

export default memo(EditionModalRadioGroup);
